import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import classes from "./password_change.module.css"
import TextInput from "../inputs/text_input"
import Refresh from '@/assets/svg/icons/refresh-cw.svg';
import Eye from '@/assets/svg/icons/eye.svg';
import EyeOff from '@/assets/svg/icons/eye-off.svg';
import CustomButton from "../buttons/button";
import { generateRandomPassword } from "@/functions/generate_password";

const PasswordReset = forwardRef(function PasswordReset({registration, required, handleBackendError, backendError, setBackendError}, ref) {
    const [password, setPassword] = useState({
        password: {val: "", type: true, isError: false},
        new_password: {val: "", type: true, isError: false},
        re_password: {val: "", type: true, isError: false}
    });

    useEffect(() => {
        if(handleBackendError && backendError) {
            setPassword(prev => ({
                ...prev,
                password: {
                    ...prev.password,
                    isError: "A régi jelszó nem megfelelő"
                }
            }))
        }
    }, [handleBackendError, backendError])

    const handlePasswordChange = (field, val) => {
        if(field === "password" && handleBackendError) {
            setBackendError(false);
        }
        
        setPassword(prev => ({
            ...prev,
            [field]: {
                ...prev[field],
                val: val,
                isError: false
            }
        }))
    }

    const setPasswordVisibility = (field) => {
        setPassword(prev => ({
            ...prev,
            [field]: {
                ...prev[field],
                type: !password[field].type
            }
        }))
    }

    const validateNewPassword = () => {
        const lowercaseRegex = /\p{Ll}/u;
        const uppercaseRegex = /\p{Lu}/u;
        const numericRegex = /\p{Nd}/u;

        if(password.new_password.val.length < 8) {
            setPassword(prev => ({
                ...prev,
                new_password: {
                    ...prev.new_password,
                    isError: "A jelszónak legalább 8 karakter hosszúnak kell lennie!"
                }
            }))
            return false;
        } else if (!lowercaseRegex.test(password.new_password.val) || !uppercaseRegex.test(password.new_password.val) ||!numericRegex.test(password.new_password.val)) {
            setPassword(prev => ({
                ...prev,
                new_password: {
                    ...prev.new_password,
                    isError: "A jelszónak tartalmaznia kell kis-, nagybetűt és számot!"
                }
            }))
            return false;
        }
        
        return true;
    }

    useImperativeHandle(ref, () => {
        return {
            validate() {
                //Reset errors before check
                setPassword(prev => ({
                    password: {...prev.password, isError: false},
                    new_password: {...prev.new_password, isError: false},
                    re_password: {...prev.re_password, isError: false}
                }))
                //Empty password fields -> submit without password changing
                if(!password.password.val.trim() && !password.new_password.val.trim() && !password.re_password.val.trim() && !registration && !required) return {}
                else {
                    for(let i in password) {
                        if(!password[i].val.trim()) {
                            if(i === "password" && registration) continue;
                            setPassword(prev => ({...prev, [i]: {...prev[i], isError: (registration ? "Kötelező mező" : "Jelszó módosításhoz kötelező kitölteni az összes jelszó mezőt!")}}))
                            return false;
                        }
                    }
                    if(!validateNewPassword()) return false;
                    if(password.new_password.val !== password.re_password.val) {
                        setPassword(prev => ({
                            ...prev,
                            re_password: {
                                ...prev.re_password,
                                isError: "A két jelszó nem egyezik!"
                            }
                        }))
                        return false;
                    }
                    return {
                        oldpassword: password.password.val,
                        password: password.new_password.val,
                        repassword: password.re_password.val
                    }
                }
            }
        }
    });

    const generatePassword = () => {
        let new_pwd = generateRandomPassword();

        setPassword(prev => ({
            ...prev,
            new_password: {
                isError: false,
                val: new_pwd,
                type: false
            },
            re_password: {
                isError: false,
                val: new_pwd,
                type: false
            }
        }))
    }

    return <>
        {!registration && <TextInput className={`w-100`} value={password.password.val} onChange={e => handlePasswordChange("password", e.target.value)} type={password.password.type ? "password" : "text"} label={"Jelenlegi jelszó"} placeholder={"Jelenlegi jelszó"} hint={password.password.isError} error={password.password.isError} help_icon={password.password.type ? Eye : EyeOff} help_icon_click={() => setPasswordVisibility("password")} autoComplete="password" />}
        <div className="d-flex flex-column align-self-stretch" style={{gap: 6}}>
            <div className="d-flex flex-row text-nowrap gap-1 color-gray-700 text-sm-medium">
                {(registration ? "Jelszó" : "Új jelszó")}
                {registration && <div className="color-error-600">*</div>}
            </div>
            <div className={`w-100 ${classes["new-password-container"]}`}>
                <TextInput className={`w-100 ${classes["new-password"]}`} value={password.new_password.val} onChange={e => handlePasswordChange("new_password", e.target.value)} type={password.new_password.type ? "password" : "text"} placeholder={(registration ? "Jelszó" : "Új jelszó")} help_icon={password.new_password.type ? Eye : EyeOff} help_icon_click={() => setPasswordVisibility("new_password")} error={password.new_password.isError} required_mark={registration} autoComplete="password" />
                <CustomButton className={`${classes["new-password-button"]} show-on-pc-480`} size="lg" hierarchy="secondary-gray" icon="leading" is_svg={true} svg={Refresh} onClick={generatePassword} type="button" >Generálás</CustomButton>
                <CustomButton className={`${classes["new-password-button"]} show-on-mobile-480`} size="lg" hierarchy="secondary-gray" icon="only" is_svg={true} svg={Refresh} onClick={generatePassword} type="button" >Generálás</CustomButton>
            </div>
            {password.new_password.isError && <p className="padding-0 margin-0 color-error-500 text-sm-regular">{password.new_password.isError}</p>}
        </div>
        <TextInput className={`w-100`} value={password.re_password.val} onChange={e => handlePasswordChange("re_password", e.target.value)} type={password.re_password.type ? "password" : "text"} label={(registration ? "Jelszó megerősítése" : "Új jelszó megerősítése")} placeholder={(registration ? "Jelszó megerősítése" : "Új jelszó megerősítése")} hint={password.re_password.isError} error={password.re_password.isError} help_icon={password.re_password.type ? Eye : EyeOff} help_icon_click={() => setPasswordVisibility("re_password")} required_mark={registration} autoComplete="password" />
    </>
})

export default PasswordReset;